import { Application } from '../../apis/eols-app-link/eols-app-link.constants';
import { AssignmentDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { CatalogPageTitleClickProps, GetAssignmentInfoProps } from '../../models/assignment-types-shared.models';
import { ApplicationNavigateHandlerMapProps,
  AssignmentTypeStrategy, CoursePlanClickSettings,
  CoursePlanPerformanceReportClickProps,
  CoursePlanTitleClickProps,
  EntityProps } from '../model';
import { getCommonSimulationLearningSystemTitleHandler,
  getCommonSimulationLearningSystemTitleHandlerClone,
  navigateExternal,
  navigateToSimchart,
  simchartCatalogTitleClick,
  simchartEditClick,
  simchartExternalEntity,
  simchartPerformanceReportClick } from '../utils/common.utils';

const getSimchartExternalEntity = (props: EntityProps) => {
  const { externalEntity, contentItem } = props;
  return simchartExternalEntity({ externalEntity, contentItem });
};

export const slsSimchartSimulationEhr: AssignmentTypeStrategy = {
  coursePlanTitleClick: (props: CoursePlanTitleClickProps) => {
    const { defArgs, sharedAppLinkParams } = props;
    const { userRole, navigateToApp } = defArgs.props;
    return navigateToSimchart(userRole, navigateToApp, sharedAppLinkParams);
  },
  coursePlanClickSettings: (props: CoursePlanClickSettings) => {
    const { defArgs, sharedAppLinkParams, assignment } = props;
    const { navigateToApp } = defArgs.props;
    simchartEditClick(assignment, navigateToApp, sharedAppLinkParams);
  },
  coursePlanPerformanceReportClick: (props: CoursePlanPerformanceReportClickProps) => {
    const { defArgs, sharedAppLinkParams } = props;
    const { navigateToApp } = defArgs.props;
    simchartPerformanceReportClick(navigateToApp, sharedAppLinkParams);
  },
  catalogPageTitleClick: (props: CatalogPageTitleClickProps) => {
    const { defArgs, contentItem } = props;
    const { navigateToApp } = defArgs.props;
    simchartCatalogTitleClick(navigateToApp, contentItem);
  },
  getExternalEntity: getSimchartExternalEntity,
  getExternalEntityClone: getSimchartExternalEntity,
  assignmentOverviewTitleClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  assignmentOverviewPerformanceReportClick: (props: ApplicationNavigateHandlerMapProps) => navigateExternal(props),
  navigateToAppForAssignmentPerformanceHandlerMap: () => Application.SIMSNG,
  navigateToAppHandlerMap: () => Application.SIMSNG,
  assignmentInfoHandler: (props: GetAssignmentInfoProps): Promise<AssignmentDto> => {
    return Promise.resolve({
      ...props.newAssignment,
      assignmentGoals: [{ goal: 1, id: null, text: null, vtwId: null }], // assignmentGoals MUST have goal, otherwise assessment can not be created from assignment
    });
  },
  isScorable: true,
  recContentItemTitleHandler: getCommonSimulationLearningSystemTitleHandler,
  recContentItemTitleHandlerClone: getCommonSimulationLearningSystemTitleHandlerClone
};
